module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-分享-浅.3de33.png";